var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('form-input',{attrs:{"label":"Name","error-message":_vm.getError('name'),"placeholder":"Name"},on:{"blur":function($event){return _vm.$emit('on-name-change', _vm.item.name)}},model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }